import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Drawer, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { setChatOpen } from 'state';
import useSocket from 'hooks/useSocket';
import ChatConversationList from './ChatConversationList';
import ChatWindow from './ChatWindow';

const DRAWER_WIDTH = 680;
const LIST_WIDTH = 260;

const ChatWidget = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const user = useSelector((state) => state.user);
  const open = useSelector((state) => state.isChatOpen);
  const { onlineUsers } = useSocket(user?._id);

  const [selectedConversation, setSelectedConversation] = useState(null);

  if (!user) return null;

  const handleSelectConversation = (conv) => setSelectedConversation(conv);
  const handleBack = () => setSelectedConversation(null);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => dispatch(setChatOpen(false))}
      variant="temporary"
      sx={{
        '& .MuiDrawer-paper': {
          width: isMobile ? '100vw' : DRAWER_WIDTH,
          height: '80vh',
          bottom: 0,
          top: 'auto',
          borderRadius: '8px 8px 0 0',
          overflow: 'hidden',
          boxShadow: 8,
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
      >
        <Box display="flex" flex={1} overflow="hidden">
          {/* Conversation list — hidden on mobile when a chat is open */}
          {(!isMobile || !selectedConversation) && (
            <Box sx={{ width: isMobile ? '100%' : LIST_WIDTH, flexShrink: 0 }}>
              <ChatConversationList
                onSelect={handleSelectConversation}
                selectedId={selectedConversation?._id}
                onlineUsers={onlineUsers}
                onClose={() => dispatch(setChatOpen(false))}
              />
            </Box>
          )}

          {/* Chat window */}
          {(!isMobile || selectedConversation) && (
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              {selectedConversation ? (
                <ChatWindow
                  conversation={selectedConversation}
                  currentUserId={user._id}
                  onBack={isMobile ? handleBack : undefined}
                  onClose={() => dispatch(setChatOpen(false))}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  sx={{ color: 'text.disabled' }}
                >
                  Select a conversation to chat
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default ChatWidget;
